module.exports = __webpack_public_path__ + "img/sb.12004173.png";